/**
* =========================================================================================
* Skeleton
* =========================================================================================
**/

import React from 'react';

const Skeleton = React.memo(props => {
    // Get Classnames
    const classNames = () => {
        let classes = 'u_skeleton';
        
        if(props?.className) { classes += ` ${props?.className}`; } 
        if(props?.rounded) { classes += ' u_skeleton-round'; }  

        return classes;
    }
    return (
        <React.Fragment>
            <div className={classNames()} style={{ width: props?.width, height: props?.height}}>                
                <div className="u_loading" />
            </div>
        </React.Fragment>
    );
});
export default Skeleton;
